import { useEffect, useState } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { IoMdArrowDropdown, IoMdArrowDropright } from "react-icons/io";

const axios = require("axios").default;

function Results() {
  let params = useParams();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [numCorrect, setNumCorrect] = useState(0);
  const [wrongFC, setWrongFC] = useState([]);
  const [flashcards, setFlashcards] = useState([""]);
  const [arrowRight, setArrowRight] = useState(true);

  useEffect(() => {
    let correctAnswers = 0;
    const userAnswers = state.userAnswers;
    const token = localStorage.getItem("token");

    for (let i = 0; i < userAnswers.length; i++) {
      if (userAnswers[i]["correct"] === true) {
        correctAnswers += 1;
      }
    }

    const wrongArr = userAnswers.filter(function (value) {
      return value.correct == false;
    });

    setNumCorrect(correctAnswers);

    axios
      .post(
        `https://application-flashcards.herokuapp.com/api/sets/${params.setname}`,
        {
          token,
        }
      )
      .then(function (response) {
        const data = response.data[0];
        const fc = data.flashcards;
        let arr = [];
        setFlashcards(fc);
        // console.log(fc);

        for (let i = 0; i < wrongArr.length; i++) {
          for (let j = 0; j < fc.length; j++) {
            if (wrongArr[i].id === fc[j].id) {
              // console.log(fc[j]);
              // setWrongFC([...wrongFC, fc[j]]);
              arr.push(fc[j]);
            }
          }
        }
        // console.log(arr);
        setWrongFC(arr);

        if (correctAnswers > data.highScore) {
          axios
            .post(
              `https://application-flashcards.herokuapp.com/api/sets/edit/${params.setname}`,
              {
                token: token,
                setname: params.setname,
                highScore: correctAnswers,
                mostRecentScore: correctAnswers,
              }
            )
            .then(function (response) {})
            .catch(function (error) {
              console.log(error);
            });
        } else {
          axios
            .post(
              `https://application-flashcards.herokuapp.com/api/sets/edit/${params.setname}`,
              {
                token: token,
                setname: params.setname,
                mostRecentScore: correctAnswers,
              }
            )
            .then(function (response) {})
            .catch(function (error) {
              console.log(error);
            });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  return (
    <>
      <div className="bg-zinc-800 text-slate-200 py-2 px-32 flex justify-between md:px-12">
        <p className="text-xl font-semibold my-2">
          {params.setname.charAt(0).toUpperCase() + params.setname.slice(1)}
        </p>
        <button
          className="text-white bg-green-400 border-neutral-50 rounded px-2 hover:bg-green-500"
          onClick={() => {
            navigate(-1);
          }}
        >
          Retake
        </button>
      </div>
      <div className="rounded-lg border-solid border border-slate-200 my-2 w-6/12 shadow-md p-2 mx-auto mt-8 md:w-10/12">
        <p className="text-2xl font-semibold mb-4">Results</p>
        <p>
          Number Correct: {numCorrect} / {flashcards.length}
        </p>
        <p>Percent: {(numCorrect / flashcards.length) * 100}%</p>
      </div>

      <div className="rounded-lg border-solid border border-slate-200 my-2 w-6/12 shadow-md p-2 mx-auto mt-2 md:w-10/12">
        <div className="flex justify-between items-center">
          <p className="text-xl my-3  font-semibold">Wrong Answers</p>
          {arrowRight ? (
            <IoMdArrowDropright
              className="mt-2 mr-3 cursor-pointer"
              style={{ height: "1.3rem", width: "1.3rem" }}
              onClick={() => {
                setArrowRight(!arrowRight);
              }}
            />
          ) : (
            <IoMdArrowDropdown
              className="mt-2 mr-3 cursor-pointer"
              style={{ height: "1.3rem", width: "1.3rem" }}
              onClick={() => {
                setArrowRight(!arrowRight);
              }}
            />
          )}
        </div>
        {arrowRight
          ? null
          : wrongFC.map((e, i) => {
              return (
                <div className="my-2" key={e.id}>
                  <div className="flex justify-between border border-red-100 rounded-md p-3 my-2 px-5 bg-red-50 hover:bg-red-100">
                    <p>Q: {e.title}</p>
                  </div>
                  <div className="flex justify-between border border-green-100 rounded-md p-3 my-2 px-5 bg-green-50 hover:bg-green-100">
                    <p>A: {e.description}</p>
                  </div>
                  <hr className="my-5" />
                </div>
              );
            })}
      </div>
    </>
  );
}

export default Results;
